import { Element } from "slate";

import { EmbedElement, EmbedType } from "components/slate/plugins/embed/types";

export const isEmbedElement = (value: any): value is EmbedElement => {
  return Element.isElementType<EmbedElement>(value, EmbedType);
};
